<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'ApplyLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '单位备案'
            },
            {
              key: '2',
              title: '报名管理'
            },
            {
              key: '3',
              title: '项目报名管理'
            },
            {
              key: '4',
              title: '信息确认管理'
            },
            // {
            //   key: '5',
            //   title: '食宿信息管理'
            // }
          ],
          active: () => {
            switch (this.$route.path) {
              case '/sai/DanweiList':
                return '1'
              case '/sai/ApplyList':
                return '2'
              case '/sai/ApplySubjectList':
                return '3'
              case '/sai/ConfrimApplyList':
                return '4'
              case '/sai/TransApplyList':
                return '5'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/sai/DanweiList')
                break
              case '2':
                this.$router.push('/sai/ApplyList')
                break
              case '3':
                this.$router.push('/sai/ApplySubjectList')
                break
              case '4':
                this.$router.push('/sai/ConfrimApplyList')
                break
              case '5':
                this.$router.push('/sai/TransApplyList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>